(function () {
  const copy = {
    heading: "Get 10% Off Your First DIY Book Nook Kit",
    subheading:
      "Start your first tiny world with an instant welcome code. Perfect for book lovers, crafters, and cozy shelf displays.",
    emailPlaceholder: "Enter your email",
    emailButton: "Send My 10% Code",
    microcopy: "Instant code. No spam. Unsubscribe anytime.",
  };

  const normalized = (value) => (value || "").replace(/\s+/g, " ").trim();

  function setText(element, value) {
    if (!element || element.dataset.bnkPopupUpdated === "true") return;
    element.textContent = value;
    element.dataset.bnkPopupUpdated = "true";
  }

  function findTextElement(root, matcher, selector) {
    return Array.from(root.querySelectorAll(selector)).find((element) => matcher(normalized(element.textContent)));
  }

  function findShortTextElement(root, matcher, selector, maxLength) {
    return Array.from(root.querySelectorAll(selector)).find((element) => {
      const text = normalized(element.textContent);
      return text.length <= maxLength && matcher(text);
    });
  }

  function updateButton(button) {
    if (!button) return;
    if (button.tagName === "INPUT") {
      button.value = copy.emailButton;
      button.setAttribute("aria-label", copy.emailButton);
      return;
    }
    setText(button, copy.emailButton);
    button.setAttribute("aria-label", copy.emailButton);
  }

  function addMicrocopy(root, anchor) {
    if (!anchor || root.querySelector("[data-bnk-popup-microcopy]")) return;

    const text = document.createElement("p");
    text.dataset.bnkPopupMicrocopy = "true";
    text.textContent = copy.microcopy;
    text.style.margin = "10px 0 0";
    text.style.fontSize = "12px";
    text.style.lineHeight = "1.35";
    text.style.color = "#5f5748";
    text.style.textAlign = "center";

    anchor.insertAdjacentElement("afterend", text);
  }

  function updateRoot(root) {
    if (!root || !root.querySelectorAll) return;

    const heading =
      findTextElement(
        root,
        (text) => text.includes("Unlock 10% Off Your First Book Nook") || text === copy.heading,
        "h1,h2,h3,[role='heading']",
      ) ||
      findShortTextElement(
        root,
        (text) => text.includes("Unlock 10% Off Your First Book Nook") || text === copy.heading,
        "span,div",
        90,
      );
    setText(heading, copy.heading);

    const subheading =
      findTextElement(
        root,
        (text) => text.includes("magical book nook") && text.includes("instant code"),
        "p",
      ) ||
      findShortTextElement(
        root,
        (text) => text.includes("magical book nook") && text.includes("instant code"),
        "span,div",
        220,
      );
    setText(subheading, copy.subheading);

    const legacySubheading = findTextElement(
      root,
      (text) => text === copy.subheading,
      "p,span,div",
    );
    if (legacySubheading) legacySubheading.dataset.bnkPopupUpdated = "true";

    const email = root.querySelector("input[type='email'], input[name*='email' i]");
    if (email) {
      email.placeholder = copy.emailPlaceholder;
      email.setAttribute("aria-label", copy.emailPlaceholder);

      const label = root.querySelector(`label[for="${email.id}"]`);
      if (label && normalized(label.textContent).toLowerCase() === "email") {
        setText(label, copy.emailPlaceholder);
      }
    }

    const submitButton = Array.from(root.querySelectorAll("button, input[type='submit']")).find((button) => {
      const text = normalized(button.textContent || button.value);
      return text === "Get My 10% Off" || text === copy.emailButton;
    });
    updateButton(submitButton);
    addMicrocopy(root, submitButton);
  }

  function updateForms() {
    document.querySelectorAll("shopify-forms-embed").forEach((embed) => {
      if (!embed.shadowRoot) return;
      updateRoot(embed.shadowRoot);
    });
  }

  const observer = new MutationObserver(updateForms);

  function init() {
    updateForms();
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
    window.setTimeout(updateForms, 1500);
    window.setTimeout(updateForms, 4000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
